// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.capitalMarket_mainDiv {
  height: 44vw;
  background-color: rgb(29, 26, 54) !important;
}
.capitalMarket_textcssView {
  opacity: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(137deg, #ffb6a0 0%, #f0592a 18.54%, #253c77 100%);
  border-radius: 0px 0px 20px 20px;
  height: 11vw;
  padding: 0.7vw 0vw 0vw 0vw;
}
.capitalMarket_textcssView:hover {
  opacity: 1;
  transition: all 1s;
}
.capitalMarket_bgImage {
  background-size: cover;
  border-radius: 20px;
  margin-left: 4vw;
  margin-right: 4vw;
}
.capitalMarket_bgTop {
  height: 26vw;
}
.capitalMarket_overlyText {
  font-size: 1.3vw;
  text-align: center;
  padding: 0.5vw;
  color: #fff !important;
  line-height: 150%;
}
.capitalMarket_comText {
  display: flex;
  justify-content: center;
  margin-top: 2vw;
  font-size: 1.5vw;
}
@media (max-width: 992px) {
  .capitalMarket_comText {
    font-size: 2.1vw;
    text-align: center;
  }
}
@media (max-width: 768px) {
  .capitalMarket_comText {
    font-size: 2.5vw;
    margin-top: 4vw;
    text-align: center;
  }
}
@media (max-width: 576px) {
  .capitalMarket_comText {
    font-size: 5vw;
    margin-top: 4vw;
  }
}
@media (max-width: 1200px) {
  .capitalMarket_mainDiv {
    height: 47vw;
  }
  .capitalMarket_bgTop {
    height: 22vw;
  }
  .capitalMarket_textcssView {
    height: 18vw;
  }
}
@media (max-width: 992px) {
  .capitalMarket_mainDiv {
    height: 50vw;
  }
  .capitalMarket_overlyText {
    font-size: 2vw;
    text-align: center;
    padding: 0.5vw;
  }
  .capitalMarket_bgTop {
    height: 23vw;
  }
  .capitalMarket_textcssView {
    height: 19vw;
  }
}
@media (max-width: 768px) {
  .capitalMarket_mainDiv {
    height: 57vw;
    background-color: rgb(29, 26, 54) !important;
  }
  .capitalMarket_bgImage {
    border-radius: 20px;
  }
  .capitalMarket_bgTop {
    height: 25vw;
  }
  .capitalMarket_textcssView {
    height: 22vw;
  }
  .capitalMarket_overlyText {
    font-size: 2vw;
  }
}
@media (max-width: 576px) {
  .capitalMarket_mainDiv {
    height: 65vh;
    padding-left: 10vw;
    padding-right: 10vw;
    background-color: rgb(29, 26, 54) !important;
  }
  .capitalMarket_bgTop {
    height: 30vh;
  }
  .capitalMarket_textcssView {
    height: 25vh;
  }
  .capitalMarket_overlyText {
    font-size: 4vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/CapitalMarketCards/capitalMarketCards.scss"],"names":[],"mappings":"AACE;EACE,YAAA;EACA,4CAAA;AAAJ;AAGE;EACE,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,6EAAA;EAMA,gCAAA;EACA,YAAA;EACA,0BAAA;AANJ;AAQE;EACE,UAAA;EACA,kBAAA;AANJ;AAQE;EACE,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AANJ;AASE;EACE,YAAA;AAPJ;AAUE;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,iBAAA;AARJ;AAUE;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AARJ;AASI;EALF;IAMI,gBAAA;IACA,kBAAA;EANJ;AACF;AAQI;EAVF;IAWI,gBAAA;IACA,eAAA;IACA,kBAAA;EALJ;AACF;AAMI;EAfF;IAgBI,cAAA;IACA,eAAA;EAHJ;AACF;AAME;EACE;IACE,YAAA;EAJJ;EAME;IACE,YAAA;EAJJ;EAME;IACE,YAAA;EAJJ;AACF;AAME;EACE;IACE,YAAA;EAJJ;EAME;IACE,cAAA;IACA,kBAAA;IACA,cAAA;EAJJ;EAME;IACE,YAAA;EAJJ;EAME;IACE,YAAA;EAJJ;AACF;AAME;EACE;IACE,YAAA;IACA,4CAAA;EAJJ;EAME;IACE,mBAAA;EAJJ;EAME;IACE,YAAA;EAJJ;EAME;IACE,YAAA;EAJJ;EAME;IACE,cAAA;EAJJ;AACF;AAME;EACE;IACE,YAAA;IACA,kBAAA;IACA,mBAAA;IACA,4CAAA;EAJJ;EAME;IACE,YAAA;EAJJ;EAME;IACE,YAAA;EAJJ;EAME;IACE,cAAA;EAJJ;AACF","sourcesContent":[".capitalMarket {\n  &_mainDiv {\n    height: 44vw;\n    background-color: rgb(29, 26, 54) !important;\n  }\n\n  &_textcssView {\n    opacity: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: linear-gradient(\n      137deg,\n      #ffb6a0 0%,\n      #f0592a 18.54%,\n      #253c77 100%\n    );\n    border-radius: 0px 0px 20px 20px;\n    height: 11vw;\n    padding: .7vw 0vw 0vw 0vw;\n  }\n  &_textcssView:hover {\n    opacity: 1;\n    transition: all 1s;\n  }\n  &_bgImage {\n    background-size: cover;\n    border-radius: 20px;\n    margin-left: 4vw;\n    margin-right: 4vw;\n  }\n\n  &_bgTop {\n    height: 26vw;\n  }\n\n  &_overlyText {\n    font-size: 1.3vw;\n    text-align: center;\n    padding: 0.5vw;\n    color: #fff !important;\n    line-height: 150%;\n  }\n  &_comText {\n    display: flex;\n    justify-content: center;\n    margin-top: 2vw;\n    font-size: 1.5vw;\n    @media (max-width: 992px) {\n      font-size: 2.1vw;\n      text-align: center;\n    }\n\n    @media (max-width: 768px) {\n      font-size: 2.5vw;\n      margin-top: 4vw;\n      text-align: center;\n    }\n    @media (max-width: 576px) {\n      font-size: 5vw;\n      margin-top: 4vw;\n    }\n  }\n\n  @media (max-width: 1200px) {\n    &_mainDiv {\n      height: 47vw;\n    }\n    &_bgTop {\n      height: 22vw;\n    }\n    &_textcssView {\n      height: 18vw;\n    }\n  }\n  @media (max-width: 992px) {\n    &_mainDiv {\n      height: 50vw;\n    }\n    &_overlyText {\n      font-size: 2vw;\n      text-align: center;\n      padding: 0.5vw;\n    }\n    &_bgTop {\n      height: 23vw;\n    }\n    &_textcssView {\n      height: 19vw;\n    }\n  }\n  @media (max-width: 768px) {\n    &_mainDiv {\n      height: 57vw;\n      background-color: rgb(29, 26, 54) !important;\n    }\n    &_bgImage {\n      border-radius: 20px;\n    }\n    &_bgTop {\n      height: 25vw;\n    }\n    &_textcssView {\n      height: 22vw;\n    }\n    &_overlyText {\n      font-size: 2vw;\n    }\n  }\n  @media (max-width: 576px) {\n    &_mainDiv {\n      height: 65vh;\n      padding-left: 10vw;\n      padding-right: 10vw;\n      background-color: rgb(29, 26, 54) !important;\n    }\n    &_bgTop {\n      height: 30vh;\n    }\n    &_textcssView {\n      height: 25vh;\n    }\n    &_overlyText {\n      font-size: 4vw;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
